<template>
  <v-row>
    <v-col xl="8" class="ma-auto">
      <v-card flat tile>
        <h3 v-if="application" class="d-flex mb-2">
          <span>{{ $t('狀態') }}：</span>
          <status-chip :status="application.status"></status-chip>
          <v-chip
            v-if="application.phone_count == 2"
            small
            class="ml-2"
          >{{ $t("第2門") }}</v-chip>
        </h3>
        <ValidationObserver ref="form" v-if="application" slim>
          <v-form>
            <v-row no-gutters class="align-center">
              <v-col cols="12">
                <v-select
                  class="required"
                  prepend-icon="mdi-credit-card-plus-outline"
                  :label="$t('門號類型')"
                  :items="types"
                  item-text="text"
                  item-value="value"
                  v-model="application.type"
                  readonly
                ></v-select>
              </v-col>
              <v-col>
                <ValidationProvider
                  name="門號"
                  :rules="`required`"
                  v-slot="{ errors }"
                  :custom-messages="{
                    required: $t('門號 為必填'),
                  }"
                  ref="phoneInput"
                >
                  <v-text-field
                    type="tel"
                    class="required"
                    :label="$t('門號')"
                    prepend-icon="mdi-cellphone"
                    maxlength="10"
                    v-model="application.sim.phone"
                    :error-messages="errors[0]"
                    readonly
                  ></v-text-field>
                </ValidationProvider>
                <ValidationProvider
                  name="卡號"
                  rules="required"
                  v-slot="{ errors }"
                  :custom-messages="{
                    required: $t('卡號 為必填'),
                  }"
                >
                  <v-text-field
                    class="required"
                    prepend-icon="mdi-sim"
                    :label="$t('卡號')"
                    v-model="application.sim.card_no"
                    :error-messages="errors[0]"
                    readonly
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-text-field
                  :label="$t('證號')"
                  v-model="application.identity_no"
                  prepend-icon="mdi-card-account-details-outline"
                  readonly
                >
                </v-text-field>
                <v-text-field
                  type="tel"
                  :label="$t('聯絡電話')"
                  prepend-icon="mdi-phone"
                  v-model="application.phone"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-img
                  v-if="signaturePreview"
                  :src="signaturePreview"
                  max-height="120"
                  contain
                >
                </v-img>
                <sign-pad-dialog
                  v-model="isSignPadDialogShown"
                  @sign="sign"
                >
                </sign-pad-dialog>
                <v-dialog
                  v-model="isCHTContractShown"
                  fullscreen
                  persistent
                  scrollable
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      depressed
                      block
                      large
                      color="primary"
                      v-on="on"
                      v-if="canEdit && !isLoading"
                    >
                      {{ $t('重簽名') }}
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>{{ $t('中華申請書') }}</v-card-title>
                    <v-carousel hide-delimiters hide-delimiter-background height="100%">
                      <v-carousel-item v-for="i in 8" :key="i">
                        <v-img
                          :src="require(`../../../img/contract-cht-page-${i}.jpg`)"
                          height="100%"
                          contain
                        ></v-img>
                      </v-carousel-item>
                    </v-carousel>
                    <v-card-actions>
                      <v-btn
                        depressed
                        block
                        color="primary"
                        @click="showSignPad"
                      >
                        {{ $t('請用正楷簽名') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <ValidationProvider name="signature" rules="required" v-slot="{ failed }">
                  <input type="hidden" v-model="signaturePreview" readonly tabindex="-1">
                  <v-alert
                    text
                    color="error"
                    icon="mdi-alert"
                    class="mt-2"
                    v-if="failed"
                  >
                    {{ $t('請閱讀申請書並簽名') }}
                  </v-alert>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-form>
        </ValidationObserver>
        <v-alert
          color="primary"
          text
          class="mb-0 mt-4"
          v-if="isLoading"
        >
          <p class="text-center">
            {{ $t('上傳中') }}
          </p>
          <v-progress-linear
            color="primary"
            indeterminate
            height="5"
          ></v-progress-linear>
        </v-alert>
        <v-card-actions class="flex-column pb-12 px-0" v-else-if="canEdit">
          <v-btn
            color="primary"
            class="ma-0 mt-4"
            large
            block
            depressed
            :loading="isLoading"
            @click="submit"
          >
            {{ $t('送件') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-dialog v-model="isSucessDialogShown" max-width="480">
      <v-card class="text-center">
        <v-card-title class="headline d-flex flex-column">
          <v-icon color="primary" x-large class="mb-5">mdi-checkbox-marked-circle</v-icon>
          {{ $t('已補簽完成，可以關閉視窗') }}
        </v-card-title>
        <v-card-actions>
          <v-btn
            depressed
            color="primary"
            class="flex-grow-1"
            @click="closeWindow"
          >
            {{ $t('關閉視窗') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { ValidationObserver, ValidationProvider } from "vee-validate";
import SignPadDialog from './components/SignPadDialog';
import StatusChip from '../../components/StatusChip';
import { APPLICATION_STATUS } from '../../libs/const';


export default {
  props: {
    hash: [String],
  },

  components: {
    StatusChip,
    SignPadDialog,
    ValidationObserver,
    ValidationProvider,
  },

  data() {
    return {
      APPLICATION_STATUS,
      canEdit: true,
      isLoading: false,
      isSucessDialogShown: false,
      isCHTContractShown: false,
      isSignPadDialogShown: false,
      signaturePreview: null,
      application: null,
    }
  },

  computed: {
    images() {
      return _.get(this.application, 'images', []);
    },

    types() {
      return [
        {
          text: this.$t('一般門號'),
          value: 'apply',
        },
        // {
        //   text: "升級",
        //   value: 'upgrade',
        // },
        // {
        //   text: "換補卡",
        //   value: 'change',
        // },
      ];
    },

    hasIssue() {
      return this.application && this.application.status == APPLICATION_STATUS.HAS_ISSUE;
    },
  },

  watch: {
    loading() {
      this.isLoading = this.loading;
    },

    application() {
      this.signaturePreview = _.get(this.images.filter(image => image.key == 'signature'), '0.url');
    },
  },

  async mounted() {
    this.isLoading = true;
    try {
      this.application = await this.fetchReSignApplication(this.hash);
      this.canEdit = [
        APPLICATION_STATUS.HAS_ISSUE,
      ].includes(this.application.status);
    } catch (error) {
      console.error(error)
      alert(this.$t("抱歉！找不到此暫存件！"));
    }
    this.isLoading = false;
  },

  methods: {
    showSignPad() {
      this.isCHTContractShown = false;
      this.isSignPadDialogShown = true;
    },

    sign(base64Image, blob) {
      this.signaturePreview = base64Image;
      this.signature = blob;
    },

    async submit() {
      const valid = await this.$refs.form.validate();
      if (!valid) {
        alert(this.$t('請檢查所有欄位是否填寫正確'));
        return;
      }

      await this.store();
    },

    async store() {
      this.isLoading = true;

      try {
        await this.reSignApplication({
          hash: this.hash,
          signature: this.signature,
        });

        this.isSucessDialogShown = true;
      } catch (error) {
        console.error(error);
        alert(this.$t("抱歉！無法暫存，請稍後再試！"));
      }

      this.isLoading = false;
    },

    closeWindow() {
      this.isSucessDialogShown = false;
      window.close();
    },

    ...mapActions(['setSnackbar']),
    ...mapActions('applications', {
      reSignApplication: 'reSign',
      fetchReSignApplication: 'fetchReSign',
    }),
  },
}
</script>

<style lang="scss" scoped>
::v-deep .required label.v-label.theme--light {
  &:before {
    content: '*';
    color: red;
  }
}
</style>
